// Module
var code = `<span ng-bind-html="previewController.trustedContent"></span> `;
// Exports
module.exports = code;